interface Accessory {
  id: number;
  description: string;
}

export function getAccessoryId(accessory: Accessory) {
  return JSON.stringify({
    id: accessory.id,
    description: accessory.description,
  });
}

export function parseAccessoryId(accessory: string) {
  return JSON.parse(accessory) as Accessory;
}
